export const autoScroll = () => {
  const element = document.querySelector('.uui-invalid');

  element?.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'nearest',
  });
};
